import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

export const StHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(64px + var(--safe-area-inset-top));
  background-color: ${({ theme }) => theme.Colors.Background.White};
  z-index: 10;
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-top: var(--safe-area-inset-top);

  box-shadow:
    0px 0px 70px rgba(205, 208, 213, 0.3),
    0px 0px 10px rgba(170, 179, 193, 0.12);

  @media ${breakpoints.m} {
    height: auto;
  }
`

export const StHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media ${breakpoints.m} {
    height: auto;
    max-width: 760px;
  }

  @media ${breakpoints.l} {
    max-width: 1160px;
    padding: ${({ theme }) => `${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space6}`};
  }
`

export const StFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: ${({ theme }) => `${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space6}`};
  padding-bottom: calc(
    ${({ theme }) => theme.UI.SpacingPx.Space3} + var(--safe-area-inset-bottom)
  );
  background: ${({ theme }) => theme.Colors.Background.White};
  box-shadow:
    0px 0px 70px rgba(205, 208, 213, 0.3),
    0px 0px 10px rgba(170, 179, 193, 0.12);
`

export const StFooterContent = styled(FlexColumn)`
  width: 100%;

  @media ${breakpoints.m} {
    height: auto;
    max-width: 760px;
  }

  @media ${breakpoints.l} {
    max-width: 1160px;
    padding: ${({ theme }) => `${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space6}`};
  }
`
